import { Component } from '@angular/core';

import { Subject } from 'rxjs';

import { EntreprisesFilters } from '../entities/entreprises-filters.entity';

@Component({
	selector: 'gestion-entreprises',
	templateUrl: 'gestion-entreprises.html',
})
export class GestionEntreprisesComponent {

	filters$ = new Subject<EntreprisesFilters>();
	
	constructor() {

	}
}